import React, { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router";
import { deleteCategory, fetchCategories } from "../api/categories";
import "./ListPage.css";
import { Button, Dialog } from "@mui/material";
import { fetchList } from "../api/list";
import { ListItem, newItem } from "../api/item";
import StarRating from "../components/StarRating";

export default function ListPage() {
  const { id } = useParams<{ id: string }>();
  const idnum = parseInt(id ?? "");
  const navigate = useNavigate();

  const [loading, setLoading] = React.useState<boolean>(true);
  const [items, setItems] = React.useState<ListItem[]>([]);
  const [catname, setCatname] = React.useState<string>("");
  const [confirmationOpen, setConfirmationOpen] =
    React.useState<boolean>(false);

  async function onDelete() {
    await deleteCategory(idnum);
    window.history.back();
  }
  async function onNew() {
    let id = await newItem(idnum);
    //now redirect to items
    navigate(`/item/${id}`);
  }
  useEffect(() => {
    async function update() {
      setLoading(true);
      const cats = await fetchCategories();
      setCatname(
        cats.find((a) => a.categoryid === idnum)?.name ?? "Unknown Category",
      );
      const items = await fetchList(idnum);
      setItems(items);
      setLoading(false);
    }
    update();
  }, [idnum, id]);

  return (
    <div className="ListPage">
      <div>
        <div className="ListPage-header">{catname}</div>
        <div className="ListPage-actions">
          <Button variant="outlined" color="primary" onClick={() => onNew()}>
            New
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => setConfirmationOpen(true)}
          >
            Delete Category
          </Button>
        </div>
      </div>
      <div className="CardList">
        {loading && <div className="Card"></div>}
        {!loading && items.length === 0 && (
          <div className="Card">No items available</div>
        )}
        {!loading &&
          items.length > 0 &&
          items.map((item) => (
            <Link
              to={`/item/${item.itemid}`}
              key={item.itemid}
              className="Card"
            >
              <h3>{item.name}</h3>
              <StarRating readonly={true} rating={item.rating} />
              <p>
                Date Visited: {new Date(item.datevisited).toLocaleDateString()}
              </p>
            </Link>
          ))}
      </div>
      <Dialog
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
      >
        <div className="Categories-dialog">
          <h2>Are you sure you want to delete this category?</h2>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              variant="outlined"
              onClick={() => setConfirmationOpen(false)}
            >
              Cancel
            </Button>
            <Button variant="contained" color="error" onClick={onDelete}>
              Delete
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
